goog.provide('el8.app.shared.dialog.billingInfoDialog');

/**
 * Helper to get Bill 2.0's Redux synchronized state for billDialogMgr.js
 * 
 * This enables legacy to detect Bill 2.0's `isOpen` state for auto-coding billing.
 */
el8.app.shared.dialog.billingInfoDialog = (function() {
  
  var that = {
    /** Read-only state synchronized by billingSlice.ts */
    _state: { isOpen: false },

    isOpen: function () {
      return that._state.isOpen;
    }
  };

  return that;

})();
